// extracted by mini-css-extract-plugin
export var modal = "_md-0";